import { parseAsStringLiteral, useQueryState } from 'nuqs'
import { GUIDE_ROLES } from './topics'

/** `?rolle=` — whose guide the hub shows. Handwerker is the default: they are the app's phone users. */
export const useGuideRole = () => {
  const [role, setRole] = useQueryState('rolle', parseAsStringLiteral(GUIDE_ROLES).withDefault('handwerker'))
  return { role, setRole }
}
